import { Component, input, output } from '@angular/core';
import { cn } from '@gametailors/web-core/tailwind';
import { cva } from 'class-variance-authority';

export type TPrefixValue = 'ge-' | 'be-' | 'ver-' | 'te-' | 'on-' | 'ont-' | 'her-';
export type TSuffixValue =
  | '-lijk'
  | '-baar'
  | '-sel'
  | '-zaam'
  | '-loos'
  | '-heid'
  | '-ster'
  | '-je'
  | '-tje'
  | '-pje'
  | '-en'
  | '-er'
  | '-el'
  | '-e'
  | '-ig'
  | '-ing';

export const MORPHEME_PREFIXES: TPrefixValue[] = ['ge-', 'be-', 'ver-', 'te-', 'on-', 'ont-', 'her-'];
export const MORPHEME_SUFFIXES_A: TSuffixValue[] = ['-lijk', '-baar', '-sel', '-zaam', '-loos', '-heid', '-ster', '-je', '-tje', '-pje'];
export const MORPHEME_SUFFIXES_B: TSuffixValue[] = ['-en', '-er', '-el', '-e', '-ig', '-ing'];

export function stripMorphemeDashes(value: string): string {
  return value.replace(/-/g, '');
}

const morphemeTileVariants = cva(
  'font-default rounded-sm border-2 px-3 py-2 text-2xl font-bold bg-white hover:bg-surface-100 border-surface-300 cursor-pointer',
  {
    variants: {
      group: {
        A: 'text-blue-500',
        B: 'text-morpheme-stem',
      },
      disabled: {
        true: 'border-transparent bg-transparent text-slate-400 hover:bg-transparent cursor-default',
        false: 'cursor-pointer',
      },
    },
    defaultVariants: {
      disabled: false,
    },
  },
);

@Component({
  selector: 'rid-morpheme-keyboard',
  imports: [],
  templateUrl: './rid-morpheme-keyboard.html',
  host: {
    class: 'block',
  },
})
export class RidMorphemeKeyboard {
  prefixDisabled = input<boolean>(false);
  suffixDisabled = input<boolean>(false);

  prefixPressed = output<TPrefixValue>();
  suffixPressed = output<TSuffixValue>();

  protected readonly prefixes = MORPHEME_PREFIXES;
  protected readonly suffixesA = MORPHEME_SUFFIXES_A;
  protected readonly suffixesB = MORPHEME_SUFFIXES_B;

  protected tileClasses(group: 'A' | 'B', disabled: boolean): string {
    return cn(morphemeTileVariants({ group, disabled }));
  }

  protected pressPrefix(value: TPrefixValue) {
    if (this.prefixDisabled()) return;

    this.prefixPressed.emit(value);
  }

  protected pressSuffix(value: TSuffixValue) {
    if (this.suffixDisabled()) return;

    this.suffixPressed.emit(value);
  }
}
